module.exports = __webpack_public_path__ + "img/banner-1-m.4fd1d42f.jpg";